// This is a skeleton starter React component generated by Plasmic.
// This file is owned by you, feel free to edit as you see fit.
import * as React from "react";
import { PlasmicDiabilityModal } from "./plasmic/cps/PlasmicDiabilityModal";
import DisabilityItem from "./DisabilityItem";
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { setComm, setHear, setMemory, setSelfCare, setSight, setWalk, showDisabilties } from "../redux/reducers/view";
import { MDBSelect } from "mdbreact";
function DiabilityModal_(props, ref) {

  const [hearingTxt, setHearing] = React.useState(false);
  const [sightTxt, setSight] = React.useState(false);
  const [disabledTxt, setDisabled] = React.useState(false);
  const [intellectualTxt, setIntellectual] = React.useState(false);
  const [emotionalTxt, setEmotional] = React.useState(false);
  const [physicalTxt, setPhysical] = React.useState(false);
  const [communicationTxt, setCommunication] = React.useState(false);

  const onChangeHearing = React.useCallback((e) => {
    setHearing(e);
    props.setHear(e)
  },[hearingTxt])


  const onChangeSight = React.useCallback((e) => {
    setSight(e);
    props.setSight(e)
  },[sightTxt])


  const onChangeDisabled = React.useCallback((e) => {
    setDisabled(e);
  },[disabledTxt])


  const onChangeIntellectual = React.useCallback((e) => {
    setIntellectual(e);
    props.setMemory(e)
  },[intellectualTxt])


  const onChangeEmotional= React.useCallback((e) => {
    setEmotional(e);
    props.setSelf(e)
  },[emotionalTxt])


  const onChangePhysical = React.useCallback((e) => {
    setPhysical(e);
    props.setWalk(e)
  },[physicalTxt])

  const onChangeCommunication = React.useCallback((e) => {
    setCommunication(e);
    props.setComm(e)
  },[communicationTxt])


  
  return (
    <div>

      {props.viewReducer.showDisabilties ? <div style={{position:'fixed', top:0, width:'100%',height:'100%', zIndex:10000000}}>
    <PlasmicDiabilityModal root={{ ref }} {...props} 
    btnClose={{
      onClick:(e)=>{
        props.showDisabilties(false)
      }
    }}
    btnFilter={{
      onClick:(e)=>{
        props.showDisabilties(false)
      }
    }}
    hearing = {{
      ratingHolder : {
        children:<MDBSelect
        name={'rating'}
        label={'Rating'}
        value={hearingTxt|| ''}
        options={props.dropdowns.dropdowns.disability_rating}
        selected={hearingTxt || ''}
        getValue={onChangeHearing}
        style={{zIndex:10000}}
      />}
    }}
    sight = {{
      ratingHolder : {
        children:<MDBSelect
        name={'rating'}
        label={'Rating'}
        value={sightTxt|| ''}
        options={props.dropdowns.dropdowns.disability_rating}
        selected={sightTxt || ''}
        getValue={onChangeSight}
        style={{zIndex:9999}}
      />}
    }}
    disabled = {{
      ratingHolder : {
        children:<MDBSelect
        name={'rating'}
        label={'Rating'}
        value={disabledTxt|| ''}
        options={props.dropdowns.dropdowns.disability_rating}
        selected={disabledTxt || ''}
        getValue={onChangeDisabled}
        style={{zIndex:9998}}
      />}
    }}
    intellectual = {{
      ratingHolder : {
        children:<MDBSelect
        name={'rating'}
        label={'Rating'}
        value={intellectualTxt|| ''}
        options={props.dropdowns.dropdowns.disability_rating}
        selected={intellectualTxt || ''}
        getValue={onChangeIntellectual}
        style={{zIndex:9997}}
      />}
    }}
    emotional = {{
      ratingHolder : {
        children:<MDBSelect
        name={'rating'}
        label={'Rating'}
        value={emotionalTxt|| ''}
        options={props.dropdowns.dropdowns.disability_rating}
        selected={emotionalTxt || ''}
        getValue={onChangeEmotional}
        style={{zIndex:9996}}
      />}
    }}
    physical = {{
      ratingHolder : {
        children:<MDBSelect
        name={'rating'}
        label={'Rating'}
        value={physicalTxt|| ''}
        options={props.dropdowns.dropdowns.disability_rating}
        selected={physicalTxt || ''}
        getValue={onChangePhysical}
        style={{zIndex:9995}}
      />}
    }}
    
    communication = {{
      ratingHolder : {
        children:<MDBSelect
        name={'rating'}
        label={'Rating'}
        value={communicationTxt|| ''}
        options={props.dropdowns.dropdowns.disability_rating}
        selected={communicationTxt || ''}
        getValue={onChangeCommunication}
        style={{zIndex:9994}}
      />}
    }}
   
    />
    </div> : null}
    </div>
  );
}

const DiabilityModal = React.forwardRef(DiabilityModal_);


const mapStateToProps = state => ({
  login: state.loginReducer,
  viewReducer: state.viewReducer,
  dropdowns: state.dropdownsReducer
});
const mapDispatchToProps = dispatch => ({
  showDisabilties: value => dispatch(showDisabilties(value)),
  setSight: value => dispatch(setSight(value)),
  setHear: value => dispatch(setHear(value)),
  setWalk: value => dispatch(setWalk(value)),
  setComm: value => dispatch(setComm(value)),
  setMemory: value => dispatch(setMemory(value)),
  setSelf: value => dispatch(setSelfCare(value)),
});

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(DiabilityModal);
